const BellIcon      = () => <Icon d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9M13.73 21a2 2 0 0 1-3.46 0" />;
const SearchIcon    = () => <Icon d="M21 21l-6-6m2-5a7 7 0 1 1-14 0 7 7 0 0 1 14 0" />;
const MenuIcon      = () => <Icon d="M3 12h18M3 6h18M3 18h18" />;
// const EditIcon      = () => <Icon d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" size={14} />;

const Icon = ({ d, size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
    <path d={d} />
  </svg>
);
// ─── Header ───────────────────────────────────────────────────────────────────
export function Header({ onMenuClick }) {
  return (
    <header className="admin_header">
      <button className="admin_header__menu-btn" onClick={onMenuClick}>
        <MenuIcon />
      </button>

      <div className="admin_header__search">
        <span className="admin_header__search-icon">
          <SearchIcon />
        </span>
        <input placeholder="Search..." />
      </div>

      <div className="admin_header__spacer" />

      <button className="admin_header__bell-btn">
        <BellIcon />
        <span className="admin_header__bell-dot" />
      </button>

      <div className="admin_header__avatar">A</div>
    </header>
  );
}